module.exports = __webpack_public_path__ + "static/img/2s-design-b3.72e6aed.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/web/2s-design-b3.jpg
// module id = BEoZ
// module chunks = 0